import PropTypes from 'prop-types'
import { DetailsContainer as Container } from '@calendly/booking-kit'
import styled from 'astroturf/react'
import _StyledDetails from "index-StyledDetails.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/cancellation/cancellation_components/details/index.js?styleId=StyledDetails";

const colorStrokeMedium = 'var(--colorStrokeMedium, var(--coreColorNeutral500))'

const StyledDetails = /*#__PURE__*/styled('div', null, {
  displayName: "StyledDetails",
  styles: _StyledDetails
})

const Details = ({ flow = 'column', ...props }) => (
  <StyledDetails>
    <Container data-container="details" flow={flow} {...props} />
  </StyledDetails>
)

Details.propTypes = {
  flow: PropTypes.oneOf(['column', 'row'])
}

export default Details
